import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
export var BREAKPOINTS = createBreakpoints({});
export var BORDER_RADIUS = 3;
export var SPACING_UNIT = 8;
export var APPBAR_SHADOW = '0px 1px 8px 0px rgba(0, 0, 0, 0.06),0px 3px 4px 0px rgba(0, 0, 0, 0.06),0px 3px 3px -2px rgba(0, 0, 0, 0.06)';
export var CARD_SHADOW = '0px 1px 5px 0px rgba(0, 0, 0, 0.06),0px 2px 2px 0px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06)';
export var ICON_COMPACT_SIZE = 18;
export var ICON_DEFAULT_SIZE = 24;
export var MENU_ITEM_HEIGHT = 48;
export var SIDEBAR_WIDTH = 250;
export var SIDEBAR_ITEM_HEIGHT = 48;
export var HEADER_HEIGHT = 56;
export var MAX_CONTAINER_WIDTH = 1200;
export var MAX_POPOVER_MOBILE_WIDTH = 260;
export var OVERLAY_BACKGROUND_COLOR = 'rgba(255, 255, 255, 0.85)';
export var TABLE_HEADER_ROW_HEIGHT = 56;
export var TABLE_BODY_ROW_HEIGHT = 48;
export var ADMIN_BAR_HEIGHT = 72;
export var LOADER_BACKGROUND_COLOR = 'linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%)';
export default {
  adminHeaderHeight: ADMIN_BAR_HEIGHT,
  headerHeight: HEADER_HEIGHT,
  sidebarWidth: SIDEBAR_WIDTH,
  menuItemHeight: MENU_ITEM_HEIGHT,
  sidebarItemHeight: SIDEBAR_ITEM_HEIGHT,
  maxContainerWidth: MAX_CONTAINER_WIDTH,
  overlayBackgroundColor: OVERLAY_BACKGROUND_COLOR,
  maxPopoverMobileWidth: MAX_POPOVER_MOBILE_WIDTH,
  tableHeaderRowHeight: TABLE_HEADER_ROW_HEIGHT,
  tableBodyRowHeight: TABLE_BODY_ROW_HEIGHT,
  loaderBackground: LOADER_BACKGROUND_COLOR
};